/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import size from "../utils/size"

import TopBar from "./top-bar"
import Logo from "./Logo"
import Navigation from "./Navigation"
import "./layout.css"

const Main = styled.main`
  margin: 0 auto;
  max-width: ${size.maxWidth}px;
`

const Footer = styled.footer`
  margin: 40px auto 10px auto;
  padding-right: 10px;
  max-width: ${size.maxWidth}px;
  text-align: right;
  color: gray;
  font-size: 0.9rem;
  font-weight: 300;
`

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <TopBar>
          <Logo siteTitle={data.site.siteMetadata.title} />
          <Navigation />
        </TopBar>
        <Main>{children}</Main>
        <Footer>© Lukas Gabriel Production {new Date().getFullYear()}</Footer>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
